import { isCssVar, isNumber } from "@chakra-ui/utils";
import { t } from "../utils";
var templates = {
  auto: "var(--chakra-transform)",
  "auto-gpu": "var(--chakra-transform-gpu)"
};

var degreeTransform = function degreeTransform(value) {
  if (isCssVar(value) || value == null) return value;
  return isNumber(value) ? value + "deg" : value;
};

export var transform = {
  transform: {
    property: "transform",
    transform: function transform(value) {
      var _templates$value;

      return (_templates$value = templates[value]) != null ? _templates$value : value;
    }
  },
  transformOrigin: true,
  translateX: t.spaceT("--chakra-translate-x"),
  translateY: t.spaceT("--chakra-translate-y"),
  rotateX: {
    property: "--chakra-rotate-x",
    transform: degreeTransform
  },
  rotateY: {
    property: "--chakra-rotate-y",
    transform: degreeTransform
  },
  skewX: {
    property: "--chakra-skew-x",
    transform: degreeTransform
  },
  skewY: {
    property: "--chakra-skew-y",
    transform: degreeTransform
  }
};